import React from 'react';
import { Input, Modal } from 'antd';
import useIsMobile from '@/hooks/useIsMobile';
import FolderPicker from '../FolderPicker';
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const ImagesModal = ({ open, onOk, onCancel }) => {
  const isMobile = useIsMobile(992);
  const viewModel = useComponent({ open, onOk, onCancel });

  return (
    <>
      {isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />}

      <Modal title='Tạo folder mới' open={viewModel.showCreateFolder} onCancel={() => viewModel.setShowCreateFolder(false)} onOk={viewModel.createFolder}>
        <Input ref={viewModel.newFolderNameInputRef} placeholder='Nhập tên thư mục mới' />
      </Modal>

      <FolderPicker
        open={viewModel.showFolderPicker}
        onCancel={() => viewModel.setShowFolderPicker(false)}
        onFolderSelected={viewModel.handleFolderPickerSelected}
      />
    </>
  );
};

export default ImagesModal;
